<div class="l_flexbar gap-full-1">
  <dgx-profile-pic
    [profile]="mention"
    size="small"
    [hideMentorIcon]="true"
    [showEngagement]="false"
  ></dgx-profile-pic>
  <div class="no-wrap font-semibold par par--small">{{ mention.name }}</div>
</div>
